import React from 'react';
import { FooterLink1, FooterLink2 } from '../../data/footer-links'; 
import { Link } from 'react-router-dom';
import { FaFacebook, FaGoogle, FaTwitter, FaYoutube } from 'react-icons/fa';
import { FcLike } from 'react-icons/fc';

const Footer = () => {
    return (
        <div className='flex items-center justify-center bg-richblack-800 max-h-fit'>
            <footer className='flex flex-col items-center justify-center w-11/12 max-w-maxContent text-richblack-400 pt-10'>
                <div className='flex gap-x-20 gap-y-6 border-b lg:flex-nowrap flex-wrap border-richblack-700 pb-5'>
                    <div className='flex justify-between w-full xl:flex-nowrap flex-wrap lg:border-b-0 border-b border-richblack-700'>
                        <div className='flex flex-row justify-between sm:w-[60%] w-full flex-nowrap'>
                            <div className='flex flex-col gap-3 mb-8 lg:ml-0 ml-8'>
                                <Link to={'/'} className='py-2'>
                                    <div className='md:text-[1.7rem] text-[1.4rem] md:font-semibold font-[800] text-white'>StudyNexaa</div>
                                </Link>
                                <div className='text-white text-md'>Company</div>
                                <Link to={'/about'}><div className='text-[14px] hover:text-richblack-50'>About</div></Link>
                                <Link to={'/careers'}><div className='text-[14px] hover:text-richblack-50'>Careers</div></Link>
                                <Link to={'/affiliates'}><div className='text-[14px] hover:text-richblack-50'>Affiliates</div></Link>
                                <div className='flex gap-3 text-lg my-3'>
                                    <div>
                                        <Link to={'http://facbook.com'} target='_blank'><FaFacebook /></Link>
                                    </div>
                                    <div>
                                        <Link to={'http://google.com'} target='_blank'><FaGoogle /></Link>
                                    </div>
                                    <div>
                                        <Link to={'http://twitter.com'} target='_blank'><FaTwitter /></Link>
                                    </div>
                                    <div>
                                        <Link to={'http://youtube.com'} target='_blank'><FaYoutube /></Link>
                                    </div>
                                </div>
                            </div>
                            <div className='flex flex-wrap justify-start md:justify-center gap-x-28'>
                                <div className='flex flex-wrap flex-col gap-3 ml-8'>
                                    <div>
                                        <div className='text-white text-md my-2'>{FooterLink1[0].title}</div>
                                        <div>{
                                            FooterLink1[0].links.map((element, i) => {
                                                return (
                                                    <Link key={i} to={element.link}><div className='text-[14px] hover:text-richblack-50 my-3 w-full'>{element.title}</div></Link>
                                                )
                                            })}
                                        </div>
                                    </div>
                                    <div>
                                        <div className='text-white text-md my-2'>{FooterLink1[1].title}</div>
                                        <div> {
                                            FooterLink1[1].links.map((element, i) => {
                                                return (
                                                    <Link key={i} to={element.link}><div className='text-[14px] hover:text-richblack-50 my-3 w-full'>{element.title}</div></Link>
                                                )
                                            })}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='flex flex-col gap-3 lg:ml-20 ml-8 w-[9rem]'>
                            <div>
                                <div className='text-white text-md my-2'>{FooterLink1[2].title}</div>
                                <div>{
                                    FooterLink1[2].links.map((element, i) => {
                                        return (
                                            <Link key={i} to={element.link}><div className='text-[14px] hover:text-richblack-50 my-3 w-full'>{element.title}</div></Link>
                                        )
                                    })}
                                </div>
                            </div>
                            <div>
                                <div className='text-white text-md my-2'>{FooterLink1[3].title}</div>
                                <div>{
                                    FooterLink1[3].links.map((element, i) => {
                                        return (
                                            <Link key={i} to={element.link}><div className='text-[14px] hover:text-richblack-50 my-3 w-full'>{element.title}</div></Link>
                                        )
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='flex lg:flex-nowrap flex-wrap justify-between lg:border-l border-richblack-700 w-full gap-x-28 gap-y-8 pl-5'>
                        {
                            FooterLink2.map((element, index) => {
                                return (
                                    <div key={index}>
                                        <div className='text-white text-md my-2'>{element.title}</div>
                                        {
                                            element.links.map((element, index) => {
                                                return (
                                                    <Link to={element.link} key={index}><div className='text-[14px] hover:text-richblack-50 my-3 w-full'>{element.title}</div></Link>
                                                )
                                            })
                                        }
                                    </div>
                                )
                            })}
                    </div>
                </div>
                <div className='w-full flex md:flex-row flex-col gap-y-4 justify-between items-center py-12'>
                    <div className='flex items-center justify-between'>
                        <Link to={'/privacy-policy'}><div className='px-3 border-r text-sm border-richblack-700'>Privacy Policy</div></Link>
                        <Link to={'/cookie-policy'}><div className='px-3 border-r text-sm border-richblack-700'>Cookie Policy</div></Link>
                        <Link to={'/terms'}><div className='px-3 text-sm'>Terms</div></Link>
                    </div>
                    <div>
                        <p className='flex text-sm items-center justify-center device-less-386'><span>Made with</span> <span><FcLike className='mx-2' /></span> <span> by Aman Choudhary </span> <span className='ml-1'>@ 2023 StudyNexaa</span></p>
                    </div>
                </div>
            </footer>
        </div>
    );
}

export default Footer;